import createClient from 'openapi-fetch';
import type { Client } from 'openapi-fetch';

import type { AuthSession } from '../ports';
import { createAuthorizedFetch } from './createAuthorizedFetch';

export function createApiClient<Paths extends object>(
  baseUrl: string,
  auth: AuthSession,
): Client<Paths> {
  return createClient<Paths>({ baseUrl, fetch: createAuthorizedFetch(auth) });
}
